import { useContext } from 'react';
import { AuthContext } from '~/contexts/authentication';

interface IUseUserRole {
  userRoles: string[];
  hasRole: (role: string) => boolean;
  hasAnyRole: (roles: string[]) => boolean;
}

export function useUserRole(): IUseUserRole {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error('useUserRole must be used within an AuthProvider');
  }

  const { userRoles, hasRole, hasAnyRole } = context;

  return { userRoles, hasRole, hasAnyRole };
}
